/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStorefrontCheckoutConfig200ResponseConfig
 */
export interface GetStorefrontCheckoutConfig200ResponseConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontCheckoutConfig200ResponseConfig
     */
    askForCutlery: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetStorefrontCheckoutConfig200ResponseConfig
     */
    allowTips: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontCheckoutConfig200ResponseConfig
     */
    hideTipsUntilUserAction: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetStorefrontCheckoutConfig200ResponseConfig
     */
    tipPresets: Array<number>;
}

/**
 * Check if a given object implements the GetStorefrontCheckoutConfig200ResponseConfig interface.
 */
export function instanceOfGetStorefrontCheckoutConfig200ResponseConfig(value: object): value is GetStorefrontCheckoutConfig200ResponseConfig {
    if (!('askForCutlery' in value) || value['askForCutlery'] === undefined) return false;
    if (!('allowTips' in value) || value['allowTips'] === undefined) return false;
    if (!('hideTipsUntilUserAction' in value) || value['hideTipsUntilUserAction'] === undefined) return false;
    if (!('tipPresets' in value) || value['tipPresets'] === undefined) return false;
    return true;
}

export function GetStorefrontCheckoutConfig200ResponseConfigFromJSON(json: any): GetStorefrontCheckoutConfig200ResponseConfig {
    return GetStorefrontCheckoutConfig200ResponseConfigFromJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontCheckoutConfig200ResponseConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'askForCutlery': json['askForCutlery'],
        'allowTips': json['allowTips'],
        'hideTipsUntilUserAction': json['hideTipsUntilUserAction'],
        'tipPresets': json['tipPresets'],
    };
}

export function GetStorefrontCheckoutConfig200ResponseConfigToJSON(json: any): GetStorefrontCheckoutConfig200ResponseConfig {
    return GetStorefrontCheckoutConfig200ResponseConfigToJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponseConfigToJSONTyped(value?: GetStorefrontCheckoutConfig200ResponseConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'askForCutlery': value['askForCutlery'],
        'allowTips': value['allowTips'],
        'hideTipsUntilUserAction': value['hideTipsUntilUserAction'],
        'tipPresets': value['tipPresets'],
    };
}

